import {
  SetProcedureFilter,
  SetRecordFilter,
  SetTaskFilter,
  SetDocumentsFilter,
  SetAccessRequestFilter,
  SetBreachFilter,
  SetCompanyFilter,
} from './actionTypes'
import {
  UpdateProcedureFilter,
  UpdateRecordFilter,
  UpdateTaskFilter,
  UpdateDocumentFilter,
  UpdateAccessRequestFilter,
  UpdateBreachFilter,
  UpdateCompanyFilter,
} from './mutationTypes'

const actions = {
  async [SetProcedureFilter]({ commit }, { type, value }) {
    commit(UpdateProcedureFilter, {
      type,
      value,
    })
  },

  async [SetRecordFilter]({ commit }, { type, value }) {
    commit(UpdateRecordFilter, {
      type,
      value,
    })
  },

  async [SetTaskFilter]({ commit }, { type, value, key, label }) {
    commit(UpdateTaskFilter, {
      type,
      key,
      label,
      value,
    })
  },
  async [SetDocumentsFilter]({ commit }, { key, value }) {
    commit(UpdateDocumentFilter, {
      key,
      value,
    })
  },

  async [SetAccessRequestFilter]({ commit }, { key, value }) {
    commit(UpdateAccessRequestFilter, {
      key,
      value,
    })
  },
  async [SetBreachFilter]({ commit }, { key, value }) {
    commit(UpdateBreachFilter, {
      key,
      value,
    })
  },

  async [SetCompanyFilter]({ commit }, { key, value }) {
    commit(UpdateCompanyFilter, {
      key,
      value,
    })
  },
}

export default actions
